/* PLAB-05 (#78). Was an inline <script> in snippets/c-modal-media.liquid. It is a sibling of
   component-modal-media.js rather than part of it, because that file is a minified browserify
   bundle with no source in this repository. */

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("c-modal-media");
  if (!modal) return;

  const closeBtn = modal.querySelector(".js-modal-media__close");
  const prevBtn = modal.querySelector(".js-modal-media__button--prev");
  const nextBtn = modal.querySelector(".js-modal-media__button--next");
  const swiperContainer = modal.querySelector(".js-modal-media__swiper");
  const currentSlideDisplay = modal.querySelector(".js-modal-media__current-slide");
  const inner = modal.querySelector(".c-modal-media__container");

  const zoomInBtn = modal.querySelector(".js-zoom-in");
  const zoomOutBtn = modal.querySelector(".js-zoom-out");

  if (!swiperContainer) return;

  let swiperInstance = null;
  let globalHandlersAttached = false;

  /* ---------------------------------------------
     Counter helper
  --------------------------------------------- */
  function updateCounter() {
    if (!currentSlideDisplay || !swiperInstance) return;

    const rawIndex =
      typeof swiperInstance.realIndex === "number"
        ? swiperInstance.realIndex
        : swiperInstance.activeIndex || 0;

    currentSlideDisplay.textContent = rawIndex + 1;
  }

  /* ---------------------------------------------
     Global listeners (ESC + outside click)
  --------------------------------------------- */
  function onKeyDown(e) {
    if (e.key === "Escape") {
      closeModal();
    }
  }

  function onDocumentClick(e) {
    if (inner && !inner.contains(e.target)) {
      closeModal();
    }
  }

  function attachGlobalHandlers() {
    if (globalHandlersAttached) return;
    globalHandlersAttached = true;

    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("click", onDocumentClick);
  }

  function detachGlobalHandlers() {
    if (!globalHandlersAttached) return;
    globalHandlersAttached = false;

    document.removeEventListener("keydown", onKeyDown);
    document.removeEventListener("click", onDocumentClick);
  }

  /* ---------------------------------------------
     Init Swiper with ZOOM module
  --------------------------------------------- */
  swiperInstance = new Swiper(swiperContainer, {
    loop: false,

    zoom: {
      maxRatio: 2,
      minRatio: 1,
    },

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },

    on: {
      init: updateCounter,
      slideChange: () => {
        // Reset zoom on slide change to avoid weird behaviors
        if (swiperInstance.zoom && swiperInstance.zoom.out) {
          swiperInstance.zoom.out();
        }
        updateCounter();
      },
    },
  });

  if (typeof swiperInstance.init === "function") {
    swiperInstance.init();
  }

  /* ---------------------------------------------
     ZOOM BUTTON HANDLERS
  --------------------------------------------- */
  if (zoomInBtn) {
    zoomInBtn.addEventListener("click", () => {
      if (swiperInstance?.zoom?.in) {
        swiperInstance.zoom.in();
      }
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener("click", () => {
      if (swiperInstance?.zoom?.out) {
        swiperInstance.zoom.out();
      }
    });
  }

  /* ---------------------------------------------
     PUBLIC: open / close
  --------------------------------------------- */
  function openModal(startIndex = 0) {
    if (!swiperInstance) return;

    const index = Number(startIndex) || 0;

    modal.style.display = "block";
    modal.classList.add("is-open", "fade-in");

    if (typeof swiperInstance.slideToLoop === "function") {
      swiperInstance.slideToLoop(index, 0);
    } else {
      swiperInstance.slideTo(index, 0);
    }

    // Always reset zoom when opening
    if (swiperInstance.zoom?.out) {
      swiperInstance.zoom.out();
    }

    updateCounter();
    setTimeout(attachGlobalHandlers, 0);

    console.log("[MODAL OPEN]", index);
  }

  function closeModal() {
    modal.classList.remove("is-open", "fade-in");
    modal.style.display = "none";

    // Reset zoom when closing
    if (swiperInstance.zoom?.out) {
      swiperInstance.zoom.out();
    }

    detachGlobalHandlers();
    console.log("[MODAL CLOSE]");
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      closeModal();
    });
  }

  /* ---------------------------------------------
     Expose to global
  --------------------------------------------- */
  window.WOOPF = window.WOOPF || {};
  window.WOOPF.openModalMedia = openModal;
  window.WOOPF.closeModalMedia = closeModal;

  /* ---------------------------------------------
     MOBILE / THEME fullscreen buttons
  --------------------------------------------- */
  document
    .querySelectorAll(".js-product-gallery__main-fullscreen")
    .forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const index = parseInt(btn.dataset.index || "0", 10);
        openModal(index);
      });
    });

  console.log("[MODAL READY]");
});
